
      <div class="col-lg-6 col-xs-12">

          <div class="panel panel-default">
              <div class="panel-body">


    <div>
      <div style="display: block">
        <canvas baseChart
                [datasets]="barChartData"
                [labels]="barChartLabels"
                [options]="barChartOptions"
                [legend]="barChartLegend"
                [chartType]="barChartType"></canvas>
      </div>
    </div>

  </div>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/report/charts/bar-chart/bar-chart.component.html